module.exports = __webpack_public_path__ + "static/img/device_name.d5a2b09.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/device_name.png
// module id = w+pc
// module chunks = 2